/* eslint-disable @typescript-eslint/no-empty-function */
import React, { type ReactNode, useMemo } from 'react'
import { RouterContext as NextRouterContext } from 'next/dist/shared/lib/router-context'

export interface IRouterContext {
  beforePopState?: () => void
}

export const noop = () => Promise.resolve(false)
export const noopPrefech = () => Promise.resolve(undefined)

export const RouterProviderOnlyForTestingPurposes = ({
  children,
  beforePopState = () => {},
}: IRouterContext & { children: ReactNode }) => {
  if (process.env.NODE_ENV !== 'test') {
    throw new Error(
      'RouterProviderOnlyForTestingPurposes cannot be used outside of a test environment'
    )
  }

  const contextValue = useMemo(
    () => ({
      route: '/',
      pathname: '/',
      asPath: '/',
      query: {},
      back: noop,
      replace: noop,
      prefetch: noopPrefech,
      push: noop,
      beforePopState,
      reload: noop,
      events: {
        on: noop,
        off: noop,
        emit: noop,
      },
      basePath: '',
      isFallback: false,
      isLocaleDomain: false,
      isReady: true,
      isPreview: false,
    }),
    [beforePopState]
  )

  return <NextRouterContext.Provider value={contextValue}>{children}</NextRouterContext.Provider>
}
